import {
  ProjectOutlined,
  UserOutlined,
  UserSwitchOutlined
} from '@ant-design/icons'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { getActivePath } from '@crm/utils'
import { Col, Menu, Row } from 'antd'

import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'

import type { MenuProps } from 'antd/lib'

export const NomenclaturesLeads = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const navigate = useAppNavigate()

  const items: MenuProps['items'] = [
    {
      key: paths.admin.nomenclatures.leads.root,
      label: t('nomenclature.types'),
      icon: <UserOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.leads.statuses,
      label: t('nomenclature.statuses'),
      icon: <UserSwitchOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.leads.sources,
      label: t('nomenclature.sources'),
      icon: <ProjectOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    }
  ]

  return (
    <Row gutter={16} wrap={false}>
      <Col xs={8} lg={7} xl={6} xxl={5}>
        <Menu items={items} defaultSelectedKeys={[getActivePath(pathname)]} />
      </Col>

      <Col flex="auto">
        <Outlet />
      </Col>
    </Row>
  )
}
